'use client';

import { useEffect } from 'react';
import { useReportWebVitals } from 'next/web-vitals';
import { addVital, startTelemetry } from '@/lib/diagnostics/client';

// Speed and errors as real visitors meet them (lib/diagnostics/client.ts).
// Renders nothing.
//
// The callback lives outside the component on purpose: useReportWebVitals registers the web-vitals observers again
// whenever the function it is given changes, and a function made inside the component is new on every render.
// Each registration left a visibilitychange listener behind: 60 of them after a hundred page changes.
function reportMetric(metric: { name: string; value: number }) {
  startTelemetry();
  addVital(metric.name, metric.value);
}

export default function Telemetry() {
  useEffect(() => {
    startTelemetry();
  }, []);
  useReportWebVitals(reportMetric);
  return null;
}
